import { useI18n } from '@ggs/i18n'
import { useModal } from '@ggs/ui/common'
import { get, noop } from 'lodash'
import { Button, EditProjectForm } from '../../index'
import { Box } from '@mui/material'
import './EditProjectAction.scss'

/**
 * @typedef {Object} EditProjectActionProps
 * @property {string} projectId Drupal project node nid
 */

/**
 * Edit project action button.
 * @param {EditProjectActionProps} props
 * @return {JSX.Element}
 */
export const EditProjectAction = ({ projectId }) => {
  const { t } = useI18n()
  const { modal, triggerModal } = useModal({
    className: 'edit-project-dialog',
    scroll: 'body',
    title: (
      <Box className="edit-project-dialog__title">
        <h2>{t('Edit Project')}</h2>
      </Box>
    ),
    content: (props) => {
      const closeModal = get(props, 'closeModal', noop)
      return <EditProjectForm projectId={projectId} closeModal={closeModal} />
    },
  })

  return (
    <>
      <Button
        label={t('Edit Project')}
        onClick={triggerModal}
        classes={{
          root: 'btn--edit'
        }}
      />
      {modal}
    </>
  )
}
